import { Component, OnInit } from '@angular/core';
import {DataserviceService} from '../../dataservice.service';
import {Router} from '@angular/router';
import { ViewChild } from '@angular/core';
import { AngularFileUploaderComponent } from "angular-file-uploader";
import { HttpErrorResponse } from '@angular/common/http';
import swal from 'sweetalert2';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';







@Component({
  selector: 'app-add-update',
  templateUrl: './add-update.component.html',
  styleUrls: ['./add-update.component.css']
})
export class AddUpdateComponent implements OnInit {
  addupdate:any={type:2,
    date:null

  }
  disableBtn:Number;
  basePath:String;
  showImage:any={};

  afuConfig = {
    multiple: false,
    formatsAllowed: ".jpg,.png",
    maxSize: "1",
    uploadAPI:  {
      url:"http://18.224.22.40:3000/api/upload"
     
    },
    // theme: "dragNDrop",
    hideProgressBar: true,
    hideResetBtn: true,
    hideSelectBtn: false
};




@ViewChild('fileUpload1')
private fileUpload1:  AngularFileUploaderComponent;

DocUpload(val){
  this.addupdate.image=JSON.parse(val.response).filename;


  
}







  constructor(private dataservice:DataserviceService,private router :Router,private parserFormatter: NgbDateParserFormatter) { }

  ngOnInit() {
    this.disableBtn=0;
    this.basePath="http://18.224.22.40:3000/api/upload?filename=";
  }

  addUpdate(){
    console.log(this.addupdate);
    
    this.disableBtn=1;
    if(this.addupdate.date){
  this.addupdate.date1 = this.parserFormatter.format(this.addupdate.date);
    }
  console.log(this.addupdate);
  
  
  // let myDate = new Date(this.addupdate.date.year, this.addupdate.date.month-1, this.addupdate.date.day);


  
  console.log("2");
  
    this.dataservice.addUpdate1(this.addupdate).subscribe(
      
      
      data=>{
        console.log(data);
        this.router.navigate(['/updates']);
        
      },
      (err : HttpErrorResponse)=>{
        this.disableBtn=0;

        console.log(err.error.error_description);

       swal(err.error.error_description);
       
      }
    )
    
  }

}
